var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PowerBiEmbed',{attrs:{"report-id":_vm.report.id,"type":"dashboard","config":_vm.config},on:{"tile-clicked":_vm.onTileClicked},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var print = ref.print;
var displayFullscreen = ref.displayFullscreen;
return [_c('EmbedHeader',{attrs:{"name":_vm.report.name},on:{"fullscreen":displayFullscreen,"back-to-workspace":function($event){return _vm.$router.push({name: 'workspace'})}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }